export default __webpack_public_path__ + "static/media/tabebuya-10.995b452b.JPG";